var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardUsage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 250,
    viewBox: "0 0 500 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2011_60889)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 250,
    fill: "#2D2F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 56.5,
    width: 97,
    height: 67,
    fill: "#CCCCCC",
    fillOpacity: 0.3,
    stroke: "#CCCCCC",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 146,
    width: 100,
    height: 70,
    fill: "#CCCCCC",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 175,
    y: 55,
    width: 100,
    height: 70,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 175,
    y: 146,
    width: 100,
    height: 70,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 285,
    y: 55,
    width: 100,
    height: 70,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 285,
    y: 146,
    width: 100,
    height: 70,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 395,
    y: 55,
    width: 100,
    height: 70,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 395,
    y: 146,
    width: 100,
    height: 70,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2011_60889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardUsage);
export default __webpack_public_path__ + "static/media/card-usage.dbe963e2a589c962b214e156aa4e6acf.svg";
export { ForwardRef as ReactComponent };